import {ProductionCostEntryStatus} from '@/Pages/Home/store/types';

export const CalculationStatusFilterOptions = [
  {
    id: 'inProduction',
    value: ProductionCostEntryStatus.InProduction,
    name: 'calculationStatus',
    label: 'In production'
  },
  {
    id: 'draft',
    value: ProductionCostEntryStatus.Draft,
    name: 'calculationStatus',
    label: 'Draft'
  },
  {
    id: 'planned',
    value: ProductionCostEntryStatus.Planned,
    name: 'calculationStatus',
    label: 'Planned'
  }
];
